export default {
  // ========== Títulos y encabezados ==========
  selectEgressProfile: 'Seleccione un {entity}',
  noAssociatedEgressProfiles: 'No hay {entity} asociados a su usuario.',

  // ========== Información y tooltips ==========
  specificEgressProfileMatters: 'Estas {entity} son las específicas de los perfiles de egreso que pueden ser únicas o compartidas.',
  baseMattersInfo: 'Estas son las {entity} que pueden ser utilizadas en varios Perfiles de Egreso, replicando sus resultados de aprendizaje.',

  // ========== Campos de tabla ==========
  code: 'Código',
  order: 'Orden',
  weeks: 'Semanas',
  planLevel: 'Nivel del Plan',
  profile: 'Perfil',
  profileType: 'Tipo de Perfil',
  studyUnits: 'Unidades de estudio',

  // ========== Acciones y botones ==========
  saveComment: 'Guardar comentario',
  viewVersion: 'Ver versión',
  applyVersion: 'Aplicar versión',
  deleteVersion: 'Eliminar versión',
  versions: 'Versiones',

  // ========== Mensajes de confirmación ==========
  sureToApplyVersion: '¿Seguro que quiere aplicar esta versión?',
  sureToDeleteVersion: '¿Seguro que quiere eliminar esta versión?',
  irreversibleChange: 'Este cambio es irreversible.',

  // ========== Mensajes de éxito ==========
  versionUpdated: 'Versión actualizada!',
  versionDeleted: 'Versión eliminada!',
  changesSavedSuccessfully: 'Cambios guardados correctamente.',

  // ========== Mensajes de error ==========
  changeNotApplied: 'No se aplicó el cambio',

  // ========== Campos de historial ==========
  modificationDate: 'Fecha de modificación',
  user: 'Usuario',
  comment: 'Comentario',
  applied: 'Aplicado',
  view: 'Vista',

  // ========== Información de perfil ==========
  noAffiliatedToEgressProfile: 'No está afiliado a ningún perfil de egreso.',
  noStudyUnits: 'No cuenta con unidades de estudio',
  profileNotFound: 'No se encontró el perfil.',
  profileTypeNotFound: 'No se encontró el tipo de perfil.',

  // ========== Mensajes de reversión ==========
  revertedToVersion: 'Revertido a la versión anterior, guardada el:',

  // ========== Mensajes de estado ==========
  changeStateTooltip: 'Cambiar el estado del {entity}',
  noHas: 'No cuenta con',

  // ========== Actualización de archivos ==========
  updateExcel: 'Actualizar excel {entity}',
  uploading: 'Subiendo...',
  pleaseWaitUpload: 'Por favor, espera mientras se sube el archivo.',
  fileUploadedSuccessfully: '¡Archivo subido exitosamente!',
  problemUploadingFile: '¡Hubo un problema al subir el archivo!',
}
